var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 0.833008H9.83268V2.49967H13.166C14.541 2.49967 15.666 3.62467 15.666 4.99967C15.666 6.37467 14.541 7.49967 13.166 7.49967H9.83268V9.16634H13.166C15.466 9.16634 17.3327 7.29967 17.3327 4.99967C17.3327 2.69967 15.466 0.833008 13.166 0.833008ZM8.16601 7.49967H4.83268C3.45768 7.49967 2.33268 6.37467 2.33268 4.99967C2.33268 3.62467 3.45768 2.49967 4.83268 2.49967H8.16601V0.833008H4.83268C2.53268 0.833008 0.666016 2.69967 0.666016 4.99967C0.666016 7.29967 2.53268 9.16634 4.83268 9.16634H8.16601V7.49967ZM5.66601 4.16634H12.3327V5.83301H5.66601V4.16634Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.51421c5c0acbe59b5f081eea5e99ac05.svg";
export { ForwardRef as ReactComponent };